import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "@windmill/react-ui";

const RejectModal = ({
  isOpen,
  onClose,
  title = "Confirm Action",
  message = "",
  content = "",
  onYesClick,
  driverHistory,
  newStatus,
  onRejectClick,
  customClass = "",
  billStatus,
}) => {
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  // Reset state when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setRemark("");
      setError("");
    }
  }, [isOpen]);

  const handleReject = () => {
    if (!remark) {
      setError("Remark is required!");
      return;
    }
    setError(""); // Clear error if any
    onRejectClick(remark);
  };

  const handleApprove = () => {
    onYesClick();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`relative bg-white dark:bg-gray-700 pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
      aria-labelledby="modal-title"
    >
      <span id="modal-title" className="flex text-2xl text-green-500">
        {title}
      </span>
      <ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
        {newStatus === 5 && (
          <p>
            <div>
              {" "}
              <b>Details to Update</b>
              {driverHistory?.vendor_name && (
                <p>
                  <strong>Vendor Name:</strong> {driverHistory.vendor_name}
                </p>
              )}
              {driverHistory?.driver_name && (
                <p>
                  <strong>Driver Name:</strong> {driverHistory.driver_name}
                </p>
              )}
              {driverHistory?.driver_contact_no && (
                <p>
                  <strong>Contact No:</strong> {driverHistory.driver_contact_no}
                </p>
              )}
              {driverHistory?.driving_license && (
                <p>
                  <strong>Driving License:</strong>{" "}
                  {driverHistory.driving_license}
                </p>
              )}
              {driverHistory?.aadhaar_no && (
                <p>
                  <strong>Aadhaar No:</strong> {driverHistory.aadhaar_no}
                </p>
              )}
              {driverHistory?.language_known && (
                <p>
                  <strong>Language Known:</strong>{" "}
                  {driverHistory.language_known}
                </p>
              )}
              {driverHistory?.driver_img && (
                <p>
                  <strong>Driver Image:</strong>{" "}
                  <img src={driverHistory.driver_img} alt="Driver" />
                </p>
              )}
              {driverHistory?.license_img && (
                <p>
                  <strong>License Image:</strong>{" "}
                  <img src={driverHistory.license_img} alt="License" />
                </p>
              )}
              {/* Add other fields as needed */}
            </div>
          </p>
        )}
        {onRejectClick && (
          <textarea
            className="w-full border border-gray-300 rounded p-2 mt-4"
            placeholder="Enter remarks..."
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            style={{ height: "100%", minHeight: "150px", maxHeight: "300px" }}
          />
        )}
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        <div className="flex items-center justify-around gap-4 mt-8">
          <Button
            onClick={handleReject}
            className="bg-red-500 hover:bg-red-600 text-white w-full sm:w-auto"
          >
            Reject
          </Button>
          {billStatus === "loss" && (
            <p className="text-red-500 mt-2">
              Cannot approve, the bill amount is a loss.
            </p>
          )}
          <Button
            onClick={handleApprove}
            className="bg-green-500 hover:bg-green-600 text-white w-full sm:w-auto"
            disabled={billStatus === "loss"}
          >
            Approve
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default React.memo(RejectModal);
